var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBindSuccess = function SvgBindSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 88c22.091 0 40-17.909 40-40S70.091 8 48 8 8 25.909 8 48s17.909 40 40 40Z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.65 64.667 25.777 48.672l4.476-4.51L41.65 55.613l24.096-24.28 4.476 4.542L41.65 64.667Z",
    fill: "#000"
  })));
};
export { SvgBindSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ4IDg4QzcwLjA5MTQgODggODggNzAuMDkxIDg4IDQ4Qzg4IDI1LjkwODYgNzAuMDkxNCA4IDQ4IDhDMjUuOTA4NiA4IDggMjUuOTA4NiA4IDQ4QzggNzAuMDkxIDI1LjkwODYgODggNDggODhaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQxLjY1MDMgNjQuNjY3TDI1Ljc3NzMgNDguNjcxN0wzMC4yNTM1IDQ0LjE2MTFMNDEuNjUwMyA1NS42MTM1TDY1Ljc0NTYgMzEuMzMzM0w3MC4yMjE4IDM1Ljg3NThMNDEuNjUwMyA2NC42NjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";